// // src/pages/LoudnessPage.js
// import React, { useContext, useState } from 'react';
// import { Box, FormControl, InputLabel, Select, MenuItem, Slider, Button, Snackbar, Typography } from '@mui/material';
// import { SettingsContext } from '../context/SettingsContext';

// export default function LoudnessPage() {
//   const { loudnessSettings, setLoudnessSettings, setHasSavedLoudness } = useContext(SettingsContext);
//   const [ear, setEar] = useState(loudnessSettings?.ear || 'Left');
//   const [loudness, setLoudness] = useState(loudnessSettings?.loudness || 70);
//   const [pitch, setPitch] = useState(loudnessSettings?.pitch || 250);
//   const [openSnackbar, setOpenSnackbar] = useState(false);

//   const handlePlayPitch = () => {
//     // Play pitch from src/assets/pitchtones and respect loudness as playback volume
//     try {
//       // dynamic import of the selected pitch file
//       const audio = new Audio(require(`../assets/pitchtones/${pitch}HZ.wav`));
//       // map loudness slider (0-100) to audio volume (0.0 - 1.0)
//       audio.volume = loudness / 100;
//       audio.play();
//     } catch (err) {
//       console.error('Error playing pitch tone:', err);
//     }
//   };

//   const handleSave = () => {
//     setLoudnessSettings({ ear, loudness, pitch });
//     setHasSavedLoudness(true);
//     setOpenSnackbar(true);
//   };

//   return (
//     <Box maxWidth={400} mx="auto" py={3}>
//       <Typography variant="h6" align="center" gutterBottom>
//         Pitch & Loudness
//       </Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Ear</InputLabel>
//         <Select value={ear} label="Ear" onChange={e => setEar(e.target.value)}>
//           <MenuItem value="Left">Left</MenuItem>
//           <MenuItem value="Right">Right</MenuItem>
//         </Select>
//       </FormControl>

//       <Box sx={{ mb: 3 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <InputLabel>Loudness (dB)</InputLabel>
//           <Typography>{loudness} dB</Typography>
//         </Box>
//         <Slider
//           value={loudness}
//           min={0}
//           max={100}
//           onChange={(e, v) => setLoudness(v)}
//           valueLabelDisplay="off"
//         />
//       </Box>

//       <Box sx={{ mb: 3 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <InputLabel>Pitch (Hz)</InputLabel>
//           <Typography>{pitch} Hz</Typography>
//         </Box>
//         <Slider
//           value={pitch}
//           min={250}
//           max={10000}
//           step={null}
//           marks={[250,500,1000,2000,3000,4000,5000,6000,7000,8000,9000,10000]
//             .map(v => ({ value: v }))}
//           onChange={(e, v) => setPitch(v)}
//           valueLabelDisplay="off"
//         />
//       </Box>

//       <Button variant="outlined" fullWidth onClick={handlePlayPitch} sx={{ mb: 2 }}>
//         Play Tone
//       </Button>

//       <Button variant="contained" fullWidth onClick={handleSave}>
//         SAVE
//       </Button>

//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={3000}
//         message="Pitch and Loudness saved successfully"
//         onClose={() => setOpenSnackbar(false)}
//       />
//     </Box>
//   );
// }
// src/pages/LoudnessPage.js
import React, { useContext, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Button,
  Snackbar,
  Typography
} from '@mui/material';
import { SettingsContext } from '../context/SettingsContext';
import './LoudnessPage.css';

export default function LoudnessPage() {
  const { loudnessSettings, setLoudnessSettings, setHasSavedLoudness } = useContext(SettingsContext);
  const [ear, setEar] = useState(loudnessSettings?.ear || 'Left');
  const [loudness, setLoudness] = useState(loudnessSettings?.loudness || 70);
  const [pitch, setPitch] = useState(loudnessSettings?.pitch || 250);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handlePlayPitch = () => {
    try {
      const audio = new Audio(require(`../assets/pitchtones/${pitch}HZ.wav`));
      audio.volume = loudness / 100;
      audio.play();
    } catch (err) {
      console.error('Error playing pitch tone:', err);
    }
  };

  const handleSave = () => {
    setLoudnessSettings({ ear, loudness, pitch });
    setHasSavedLoudness(true);
    setOpenSnackbar(true);
  };

  return (
    <Box className="loudness-page">
      <Typography className="page-title" variant="h6">
        Pitch & Loudness
      </Typography>

      <FormControl fullWidth className="form-row">
        <InputLabel>Ear</InputLabel>
        <Select
          value={ear}
          label="Ear"
          onChange={e => setEar(e.target.value)}
        >
          <MenuItem value="Left">Left</MenuItem>
          <MenuItem value="Right">Right</MenuItem>
        </Select>
      </FormControl>

      <Box className="form-row">
        <Box className="slider-label">
          <InputLabel>Loudness (dB)</InputLabel>
          <Typography>{loudness} dB</Typography>
        </Box>
        <Slider
          value={loudness}
          min={0}
          max={100}
          onChange={(e, v) => setLoudness(v)}
          valueLabelDisplay="off"
        />
      </Box>

      <Box className="form-row">
        <Box className="slider-label">
          <InputLabel>Pitch (Hz)</InputLabel>
          <Typography>{pitch} Hz</Typography>
        </Box>
        <Slider
          value={pitch}
          min={250}
          max={10000}
          step={null}
          marks={[250,500,1000,2000,3000,4000,5000,6000,7000,8000,9000,10000].map(v => ({ value: v }))}
          onChange={(e, v) => setPitch(v)}
          valueLabelDisplay="off"
        />
      </Box>

      {/* Button Group with proper spacing */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          fullWidth
          className="btn-outline"
          onClick={handlePlayPitch}
        >
          Play Tone
        </Button>
        <Button
          variant="contained"
          fullWidth
          className="btn-primary"
          onClick={handleSave}
        >
          SAVE
        </Button>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Pitch and Loudness saved successfully"
        onClose={() => setOpenSnackbar(false)}
      />
    </Box>
  );
}
